import upload, { dataURItoBlob } from '@ms/plugins/upload.js'

const imageTypeObj = {
  unsettled: 'UNSETTLED',
  settled: 'SETTLED',
  prized: 'PRIZED'
}

/**
 * 上传订单分享图片
 * @param  {Array}  ids [description]
 * @return {[type]}     [description]
 */
const uploadSharePics = async (orderId = '', imageType = '', fileData) => {
  const res = await upload(`/orders/real-sports/order/share/uploadSharePics/${orderId}`, {
    file: dataURItoBlob(fileData),
    imageType: imageTypeObj[imageType]
  })
  const { bizCode, message, data } = res
  console.log('res', res)
  if (bizCode === 10000) {
    return data
  } else {
    return Promise.reject(new Error(message))
  }
}

export default uploadSharePics
